import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const DURACION_MINUTOS = 30;
function formatear(valor: number) {
  return valor.toString().padStart(2, '0');
}
export function BarraOferta() {
  const [restante, setRestante] = useState(DURACION_MINUTOS * 60);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRestante(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const minutos = Math.floor(restante / 60);
  const segundos = restante % 60;
  return <div className="sticky top-0 z-50 w-full bg-frambuesa px-3 py-3 text-center shadow-md" data-id="element-16" data-mp="3o1iyehhago5d">
      <div className="mx-auto flex max-w-3xl flex-wrap items-center justify-center gap-x-4 gap-y-2" data-id="element-17" data-mp="3sukf8v122xrl">
        <span className="inline-flex items-center gap-2 font-sans text-xs font-bold uppercase tracking-[0.16em] text-white sm:text-sm sm:tracking-[0.2em]" data-id="element-18" data-mp="1mzj8ikhp4xu">
          <ClockIcon className="h-5 w-5 animate-pulse" aria-hidden="true" data-id="element-19" data-mp="anxmgyn3t8fd" />
          Oferta especial termina en
        </span>
        <span className="rounded-lg bg-white/20 px-3 py-1 font-sans text-xl font-bold tracking-widest text-white sm:text-2xl" role="timer" aria-live="off" data-id="element-20" data-mp="3qd2tc977f3dy">
          {formatear(minutos)}:{formatear(segundos)}
        </span>
      </div>
    </div>;
}